import React, {ReactElement} from "react";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import {FFairPrimaryIconGreyLogo} from "view/images/FFairLogo";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  text: {
    color: "rgba(128, 128, 128, 1)",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "14px",
    marginLeft: "8px",
  },
  container: {
    display: "flex",
    alignItems: "center",
  },
}));

const Copyright = (): ReactElement => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <FFairPrimaryIconGreyLogo width={24} height={24} />
      <Typography variant="body2" className={classes.text} align="center">
        Copyright ©&nbsp;
        <Link color="inherit" href="/">
          FFAIR Ltd
        </Link>{" "}
        {new Date().getFullYear()}.
      </Typography>
    </div>
  );
};

export default Copyright;
